import { createGetApi } from "@api/util/createGetApi";

import type { IApiResponse } from "@api";
import type { ICustomerReportsGetAllParams } from "@api/stores/customerReports/types";
import type { IFileResponse } from "@interfaces";

import type { IPathBaseParam } from "./path";

const getApis = createGetApi<
  IApiResponse<IFileResponse>,
  IPathBaseParam,
  ICustomerReportsGetAllParams
>("stores.customerReports.exportPDF");

export const exportPDF = {
  ...getApis,
};
